export const toCashback = function (value, isTooltip = false) {
    const parsedValue = Math.ceil(value);

    if (isNaN(parsedValue)) {
        return '+ ' + value;
    }

    const getBonusText = (num) => {
        const lastDigit = num % 10;
        const lastTwoDigits = num % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return 'бонусов';
        }

        switch (lastDigit) {
            case 1:
                return 'бонус';
            case 2:
            case 3:
            case 4:
                return 'бонуса';
            default:
                return 'бонусов';
        }
    };

    let tooltip = '';
    if (isTooltip) {
        tooltip = `<div class="ui-value--product-cashback-notice | js-cashback-tooltip-product" data-modal-name="cashback-info"></div>`;
    }

    return `+ ${parsedValue} ${getBonusText(parsedValue)} ${tooltip}`;
}
